module.exports = __webpack_public_path__ + "static/media/banner-amor-de-mae.a644cba4.png";